import { ValueGetterParams } from "ag-grid-community";
import { Task } from "../../../../../../services/cloudchipr.api";
import { formatDate } from "../../../../../../utils/helpers/date-time/datetime-format";

export const taskDueDateFilterText = ({ data }: ValueGetterParams<Task>) => {
  return `${formatDate(data?.due_date ?? "", { type: "date" })}`;
};
